import { render, staticRenderFns } from "./BotaoAcao.vue?vue&type=template&id=788aff58&scoped=true"
import script from "./BotaoAcao.vue?vue&type=script&lang=js"
export * from "./BotaoAcao.vue?vue&type=script&lang=js"
import style0 from "./BotaoAcao.vue?vue&type=style&index=0&id=788aff58&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788aff58",
  null
  
)

export default component.exports